export const CLIENTS_GRID_RECORD_MESSAGE = 'No records to display at this time.';
export const CLIENTS_SEARCH_INPUT_PLACEHOLDER = 'Search by Client Name or CPID';

export const CLIENTS_DROPDOWN_MENUS_ADMIN = [
  {
    id: 1,
    label: 'Add a New Fee Schedule',
  },
];

export const VIEW_GRID_COLUMNS = new Set([
  {
    dataName: 'clientName',
    text: 'Client Name',
    sortable: true,
    isSorted: 0,
    headerWidth: 300,
    isHeaderTruncated: true,
  },
  {
    dataName: 'cpid',
    text: 'CPID',
    sortable: true,
    isSorted: 0,
    headerWidth: 100,
    isHeaderTruncated: true,
  },
  {
    dataName: 'clientGroup',
    text: 'Client Group',
    sortable: true,
    isSorted: 0,
    headerWidth: 250,
    isHeaderTruncated: true,
  },
  {
    dataName: 'effectiveDate',
    text: 'Effective Date',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'termDate',
    text: 'Term Date',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'statusChip',
    text: 'Status ',
    sortable: true,
    isSorted: 0,
    cellType: 'chip',
    headerWidth: 80,
    isHeaderTruncated: true,
  },
  {
    dataName: 'street',
    text: 'Street',
    sortable: true,
    isSorted: 0,
    headerWidth: 200,
    isHeaderTruncated: true,
  },
  {
    dataName: 'city',
    text: 'City',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },

  {
    dataName: 'state',
    text: 'State',
    sortable: true,
    isSorted: 0,
    headerWidth: 100,
    isHeaderTruncated: true,
  },

  {
    dataName: 'zip',
    text: 'Zip',
    sortable: true,
    isSorted: 0,
    headerWidth: 100,
    isHeaderTruncated: true,
  },
]);

export const CLIENT_FEE_SCHEDULE_DATA_COLUMNS = new Set([
  {
    dataName: 'invoiceEntityType',
    text: 'Invoice Entity Type',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
  },
  {
    dataName: 'serviceCategory',
    text: 'Service Category',
    sortable: true,
    isSorted: 0,
    minWidth: '250px',
  },
  {
    dataName: 'selfBill',
    text: 'Self Bill',
    sortable: true,
    isSorted: 0,
    minWidth: '120px',
    cellType: 'custom',
  },
  {
    dataName: 'baseFee',
    text: 'Base Fee',
    sortable: true,
    isSorted: 0,
    minWidth: '120px',
  },
  {
    dataName: 'rateOfSavings',
    text: '% Savings',
    sortable: true,
    isSorted: 0,
    minWidth: '130px',
    align: 'right',
  },
  {
    dataName: 'rateOfBilledCharges',
    text: '% Charge',
    sortable: true,
    isSorted: 0,
    minWidth: '130px',
    align: 'right',
  },
  {
    dataName: 'effectiveDate',
    text: 'Effective Date',
    sortable: true,
    isSorted: 0,
    minWidth: '160px',
    align: 'right',
  },
  {
    dataName: 'termDate',
    text: 'Term Date',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
  {
    dataName: 'statusChip',
    text: 'Status ',
    sortable: true,
    isSorted: 0,
    cellType: 'chip',
    headerWidth: 80,
    isHeaderTruncated: true,
  },
  {
    dataName: 'createdBy',
    text: 'Created By',
    sortable: true,
    isSorted: 0,
    headerWidth: 100,
    isHeaderTruncated: true,
  },
  {
    dataName: 'feeScheduleId',
    text: 'Fee Schedule ID',
    sortable: true,
    isSorted: 0,
    headerWidth: 95,
    isHeaderTruncated: true,
  },
]);

export const CLIENT_DETAILS_COLUMNS = new Set([
  {
    dataName: 'isOffshore',
    text: 'Offshore Flag',
    sortable: false,
    isSorted: 0,
    cellType: 'custom',
    minWidth: '100px',
  },
  {
    dataName: 'clientPartnerDivID',
    text: 'Client Partner Div ID',
    sortable: true,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'divisionName',
    text: 'Division Name',
    sortable: true,
    isSorted: 0,
    minWidth: '195px',
  },
]);

export enum ActionTypesClients {
  SET_CLIENTS_DATA = 'SET_CLIENTS_DATA',
  TOGGLE_IS_CLIENTS_DATA_LOADING = 'TOGGLE_IS_CLIENTS_DATA_LOADING',
  TOGGLE_IS_CLIENT_DETAIL_LOADING = 'TOGGLE_IS_CLIENT_DETAIL_LOADING',
  SET_CLIENT_DETAIL_DATA = 'SET_CLIENT_DETAIL_DATA',
  CLEAR_CLIENT_DETAIL_PANE_REDUX_DATA = 'CLEAR_CLIENT_DETAIL_PANE_REDUX_DATA',
  SET_CLIENT_FEE_SCHEDULE_DATA = 'SET_CLIENT_FEE_SCHEDULE_DATA',
  SET_ALL_CLIENT_SERVICES = 'SET_ALL_CLIENT_SERVICES',
  TOGGLE_IS_SERVICES_DATA_LOADING = 'TOGGLE_IS_SERVICES_DATA_LOADING',
  TOGGLE_IS_CLIENT_FEE_SCHEDULE_LOADING = 'TOGGLE_IS_CLIENT_FEE_SCHEDULE_LOADING',
  TOGGLE_IS_ADD_FEE_SCHEDULE_LOADING = 'TOGGLE_IS_ADD_FEE_SCHEDULE_LOADING',
  TOGGLE_IS_TERMINATE_FEE_SCHEDULE_LOADING = 'TOGGLE_IS_TERMINATE_FEE_SCHEDULE_LOADING',
  SET_CLIENT_FEATURE_DATA = 'SET_CLIENT_FEATURE_DATA',
  TOGGLE_IS_CLIENT_FEATURE_LOADING = 'TOGGLE_IS_CLIENT_FEATURE_LOADING',
  SET_CLIENT_FEATURE_LIST = 'SET_CLIENT_FEATURE_LIST',
  SET_CLIENT_DETAILS_DATA = 'SET_CLIENT_DETAILS_DATA',
  TOGGLE_IS_CLIENT_DETAILS_LOADING = 'TOGGLE_IS_CLIENT_DETAILS_LOADING',
}
